import Temp from "@/courier/Temp";
import moment from "moment";
import courierRules from "../constants/CourierRules";
export default class KerryQuickExpress extends Temp {
  static CODE = "KRYQ";
  API_URL = this._VUE.$API_URL;
  static API = {
    checkSameAddress: "/address/province/same",
  };
  static NAME_TYPE = {
    BKKG_TO_BKKG: 1,
    BKKG_TO_UPC: 2,
    C_E_TO_BKKG: 3,
    C_E_TO_ALL: 4,
    C_E_SAME_PROVINCE: 5,
    N_NE_S_TO_BKKG: 6,
    N_TO_ALL: 7,
    NE_TO_ALL: 8,
    S_TO_ALL: 9,
    N_SAME_PROVINCE: 10,
    NE_SAME_PROVINCE: 11,
    S_SAME_PROVINCE: 12,
  };

  static NAME_TYPE_3_ZONE = {
    'SAME_PROVINCE': 1,
    'WITHIN_200KM': 2,
    'MORE_THAN_1200KM': 3
  };

  static NAME_ZONE = {
    BKKG: 1,
    C: 2,
    N: 3,
    S: 4,
    E: 5,
    NE: 6,
  };

  constructor() {
    super(KerryQuickExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;

    if ((new Date().getTime() <= new Date('2023-09-05 00:00:00').getTime())) {
      remote_area = super.checkRemoteArea(Number(item.toPostcode));
    }

    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }
    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);
    if (item.province.to == 'สมุทรสาคร') {
      to = KerryQuickExpress.NAME_ZONE.BKKG;
    }
    if ((item.from.source?item.from.province:item.sameData.province) == 'สมุทรสาคร') {
      from = KerryQuickExpress.NAME_ZONE.BKKG;
    }
    const sameProvince = super.checkSameProviceByName(item);
    type = await this.checkRateType(item, { from: from, to: to });
    let fuel_surcharge_data = await super.getFuelSurcharge();
    if (fuel_surcharge_data && new Date().getTime() >= new Date('2023-09-05 00:00:00').getTime()) {
      fuel_surcharge = fuel_surcharge_data['ZONE_' + type]?fuel_surcharge_data['ZONE_' + type]:fuel_surcharge;
    } else if (fuel_surcharge_data) { // TODO: remove after 1 sep 2023 if {}
      const sameProvinceFuelCharge =
        sameProvince || this.checkSameZoneBKKG({ from: from, to: to });
      fuel_surcharge = sameProvinceFuelCharge
        ? fuel_surcharge_data["INPROVINCE"]
        : fuel_surcharge_data["OTHERZONE"];
    }
    return {
      rate_type: type,
      fuel_surcharge: fuel_surcharge,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }
  async checkRateType(item, zone) {
    if (new Date().getTime() >= new Date('2023-09-05 00:00:00').getTime()) {
      let zoneArea = await super.getCourierZone(KerryQuickExpress.CODE);
      let kerryZoneProvince = zoneArea.data.coverageZone;
      let kerryZoneNumber = false;
      let fromAddress = item.sameData;
      if (item.from.source == 1) {
        fromAddress = item.from;
      }
      // เผื่อลูกค้าพิมเองไม่กด auto complete
      item.to.province = item.to.province.replace('จ.', '');
      if (!kerryZoneProvince[fromAddress.province] && fromAddress.province && fromAddress.province.length > 3) {
        await super.getArea([fromAddress.district + ' ' + fromAddress.state + ' ' + fromAddress.province + ' ' +fromAddress.postcode], [KerryQuickExpress.CODE]).then((res) => {
          if (res.original_data) {
            fromAddress.province = res.original_data.province.replacer
          }
        });
      }
      if (!kerryZoneProvince[item.to.province] && item.to.province && item.to.province.length > 3 ) {
        await super.getArea([item.to.district + ' ' + item.to.state + ' ' + item.to.province + ' ' +item.to.postcode], [KerryQuickExpress.CODE]).then((res) => {
          if (res.original_data) {
            item.to.province = res.original_data.province.replacer
          }
        });
      }
      // 
      if(kerryZoneProvince[fromAddress.province] && kerryZoneProvince[fromAddress.province][item.to.province]) {
        kerryZoneNumber = kerryZoneProvince[fromAddress.province][item.to.province].zone.replace('ZONE_', '');
      }
      if (kerryZoneNumber == '1') {
        return KerryQuickExpress.NAME_TYPE_3_ZONE.SAME_PROVINCE;
      } else if (kerryZoneNumber == '2') {
        return KerryQuickExpress.NAME_TYPE_3_ZONE.WITHIN_200KM;
      } else {
        return KerryQuickExpress.NAME_TYPE_3_ZONE.MORE_THAN_1200KM;
      }
    }
    if (this.checkSameZoneBKKG(zone))
      return KerryQuickExpress.NAME_TYPE.BKKG_TO_BKKG;
    if (zone.from === KerryQuickExpress.NAME_ZONE.BKKG)
      return KerryQuickExpress.NAME_TYPE.BKKG_TO_UPC;
    const checkSameProvince = await this.checkSameProvinceByZone(zone, item);
    if (checkSameProvince !== false) return checkSameProvince;

    if (
      [KerryQuickExpress.NAME_ZONE.C, KerryQuickExpress.NAME_ZONE.E].includes(
        zone.from
      )
    ) {
      if (zone.to === KerryQuickExpress.NAME_ZONE.BKKG)
        return KerryQuickExpress.NAME_TYPE.C_E_TO_BKKG;
      else return KerryQuickExpress.NAME_TYPE.C_E_TO_ALL;
    }
    const zoneN_NE_S = [
      KerryQuickExpress.NAME_ZONE.N,
      KerryQuickExpress.NAME_ZONE.NE,
      KerryQuickExpress.NAME_ZONE.S,
    ];
    if (
      zoneN_NE_S.includes(zone.from) &&
      zone.to === KerryQuickExpress.NAME_ZONE.BKKG
    )
      return KerryQuickExpress.NAME_TYPE.N_NE_S_TO_BKKG;

    if (zone.from === KerryQuickExpress.NAME_ZONE.N)
      return KerryQuickExpress.NAME_TYPE.N_TO_ALL;
    if (zone.from === KerryQuickExpress.NAME_ZONE.NE)
      return KerryQuickExpress.NAME_TYPE.NE_TO_ALL;
    if (zone.from === KerryQuickExpress.NAME_ZONE.S)
      return KerryQuickExpress.NAME_TYPE.S_TO_ALL;

    return -1;
  }
  checkSameZoneBKKG(zone) {
    if (
      zone.from === KerryQuickExpress.NAME_ZONE.BKKG &&
      zone.to === KerryQuickExpress.NAME_ZONE.BKKG
    )
      return true;
    else return false;
  }
  async checkSameProvinceByZone(zone, postcodes) {
    if (zone.from !== zone.to) return false;
    const sameProvince = await this.checkSameProvince(postcodes);
    if (!sameProvince) return false;

    if (
      zone.from === KerryQuickExpress.NAME_ZONE.C ||
      zone.from === KerryQuickExpress.NAME_ZONE.E
    )
      return KerryQuickExpress.NAME_TYPE.C_E_SAME_PROVINCE;

    if (zone.from === KerryQuickExpress.NAME_ZONE.N)
      return KerryQuickExpress.NAME_TYPE.N_SAME_PROVINCE;

    if (zone.from === KerryQuickExpress.NAME_ZONE.S)
      return KerryQuickExpress.NAME_TYPE.S_SAME_PROVINCE;

    if (zone.from === KerryQuickExpress.NAME_ZONE.NE)
      return KerryQuickExpress.NAME_TYPE.NE_SAME_PROVINCE;

    return false;
  }
  async checkSameProvince(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
    // const check = await this._VUE.$http.get(
    //   this.API_URL + KerryQuickExpress.API.checkSameAddress,
    //   {
    //     headers: {
    //       Token: localStorage.getItem("access_token"),
    //     },
    //     params: {
    //       from_postcode: item.fromPostcode,
    //       to_postcode: item.toPostcode,
    //     },
    //   }
    // );

    // try {
    //   const _check = check.data.data;
    //   if (_check.status === false) throw _check.msg;
    //   else if (_check.msg === "not within same province") return false;
    //   else return true;
    // } catch (err) {
    //   console.info(err);
    //   return false;
    // }
  }
  calculateDimensionRatio(item) {
    let dimensionRatio = 3000;
    if (item.weight > 21000) {
      dimensionRatio = 6000;
    }
    return dimensionRatio;
  }
  checkWeight(courierRates, item, validate) {
    if (!courierRates) return {index: -1};
    let dimensionRatio = this.calculateDimensionRatio(item);
    let useWeight = item.weight;
    let dimensionWeight = super.calculateDimensionWeight(item, dimensionRatio);
    useWeight = dimensionWeight > item.weight ? dimensionWeight : item.weight;
    const maxTier = courierRates[courierRates.length - 1];
    if (useWeight > maxTier.max) {
      useWeight = item.weight;
    }
    item.index = courierRates.findIndex((rate) => {
      return useWeight >= rate.min && useWeight <= rate.max;
    });
    return super.checkRules(item, validate);
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      if (new Date().getTime() >= new Date().getTime('2023-09-05 00:00:00')) {
        resolve({isRemote: 0})
      }
      super.getArea([addressRemote], [CODE]).then((res) => {
        resolve({
          isRemote: res.data.KRYQ.is_remote?50:0
        });
      });
    });
  }
}
